import { parseApiEventDate } from '../config/featuredEvents.js'

/**
 * Ordem da listagem "Todos os eventos" (2026-09-15).
 *
 * O backend envia `catalogWeight` (0-100: 70% faturamento pago acumulado e 30%
 * visualizacoes). Maior peso primeiro; no empate — inclusive eventos sem venda
 * e sem visualizacao, que pesam 0 — a data mais proxima vem antes.
 *
 * O peso so vale quando TODOS os eventos o trazem: com a flag desligada, deploy
 * parcial ou falha no calculo, a ordem da API (por data) e mantida.
 */
export function hasCatalogWeights(events) {
  return Array.isArray(events)
    && events.length > 0
    && events.every((event) => isCatalogWeight(event?.catalogWeight))
}

export function sortCatalogEvents(events) {
  if (!Array.isArray(events)) return []
  if (!hasCatalogWeights(events)) return [...events]

  return events
    .map((event, index) => ({ event, index, date: parseApiEventDate(event.date)?.getTime() ?? Infinity }))
    .sort((a, b) => b.event.catalogWeight - a.event.catalogWeight || a.date - b.date || a.index - b.index)
    .map(({ event }) => event)
}

function isCatalogWeight(value) {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 100
}
